import router from './router'
import store from './store'
import { Message } from 'element-ui'
import NProgress from 'nprogress' // progress bar
import 'nprogress/nprogress.css' // progress bar style
import { getToken } from '@/utils/auth' // get token from cookie
import getPageTitle from '@/utils/get-page-title'
import i18n from '@/lang/index'
import Vue from 'vue'

NProgress.configure({ showSpinner: false }) // NProgress Configuration

const whiteList = ['/login', '/auth-redirect'] // no redirect whitelist
const waterMarkEnvTextMap = {
  production: '生产',
  ironTest: '测试',
  test: '测试',
  test01: '测试'
}

const getWaterMarkText = (hasToken) => {
  const userText = hasToken ? store.state.user.name || '暂无用户信息' : '未登录用户'
  const envText = waterMarkEnvTextMap[process.env.VUE_APP_ENV || process.env.ENV || process.env.NODE_ENV]

  return envText ? `${userText} ${envText}` : userText
}

router.beforeEach(async (to, from, next) => {
  // start progress bar
  NProgress.start()

  // set page title
  // console.log(to.meta.title)
  document.title = getPageTitle(i18n.t(`route.${to.meta.title}`))
  // determine whether the user has logged in
  const hasToken = getToken()

  if (hasToken) {
    if (to.path === '/login') {
      // if is logged in, redirect to the home page
      next({ path: '/' })
      NProgress.done() // hack: https://github.com/PanJiaChen/vue-element-admin/pull/2939
    } else {
      // determine whether the user has obtained his permission roles through getInfo
      const hasRoles = store.getters.roles && store.getters.roles.length > 0
      if (hasRoles) {
        //同步字典选项
        //await store.dispatch('settings/syncDictionary')
        next()
      } else {
        try {
          // get user info
          // note: roles must be a object array! such as: ['admin'] or ,['developer','editor']
          const { roleIds: roles } = await store.dispatch('user/getInfo')
          // generate accessible routes map based on roles
          const accessRoutes = await store.dispatch('permission/generateRoutes', roles)

          // dynamically add accessible routes
          router.addRoutes(accessRoutes)

          await store.dispatch('settings/syncDictionary')
          // 更新$enums 优化字典、地区更新滞后问题
          Vue.prototype.$enums = store.getters.enums
          // hack method to ensure that addRoutes is complete
          // set the replace: true, so the navigation will not leave a history record
          next({ ...to, replace: true })
        } catch (error) {
          // remove token and go to login page to re-login
          await store.dispatch('user/resetToken')
          Message.error(error || 'Has Error')
          next(`/login?redirect=${to.path}`)
          NProgress.done()
        }
      }
    }
  } else {
    /* has no token*/

    if (whiteList.indexOf(to.path) !== -1) {
      // in the free login whitelist, go directly
      next()
    } else {
      // other pages that do not have permission to access are redirected to the login page.
      next(`/login?redirect=${to.path}`)
      NProgress.done()
    }
  }
  // 更新水印
  Vue.prototype.$waterMark.refresh({
    text: getWaterMarkText(hasToken)
  })
})

router.afterEach(() => {
  // finish progress bar
  NProgress.done()
})
